"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrinityClient = exports.Metadata = void 0;
var axios_1 = require("axios");
var lodash_1 = require("lodash");
var Endpoints = {
    test: {
        url: 'https://epxw9se245.execute-api.eu-central-1.amazonaws.com/test/track',
        key: 'nfi3nVygZd9lbn14NU8SG6Z4mzlwLILRaPy2PRET',
    },
    prod: {
        url: 'https://epxw9se245.execute-api.eu-central-1.amazonaws.com/prod/track',
        key: 'missing',
    },
};
var Metadata = (function () {
    function Metadata(app) {
        this.enviroment = 'test';
        this.page = '';
        this.userID = '';
        this.language = 'de';
        this.country = 'de';
        this.chatAvailability = 'unregistered';
        this.application = app;
    }
    return Metadata;
}());
exports.Metadata = Metadata;
var TrinityClient = (function () {
    function TrinityClient(stage) {
        this.metadata = new Metadata('Unknown');
        this.errorLogger = function () { };
        this.endpoint = Endpoints[stage];
    }
    TrinityClient.prototype.onLog = function (message) {
        var _this = this;
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var event = {
            name: 'log',
            payload: {
                metadata: this.metadata,
                message: message,
                params: params,
            },
        };
        axios_1.default
            .post(this.endpoint.url, event, {
            headers: {
                'x-api-key': this.endpoint.key,
            },
        })
            .catch(function (err) {
            if ((0, lodash_1.isFunction)(_this.errorLogger)) {
                _this.errorLogger(err);
            }
        });
    };
    return TrinityClient;
}());
exports.TrinityClient = TrinityClient;
//# sourceMappingURL=index.js.map